export enum B2CPolicy {
  SignUpSignIn = 'B2C_1A_SignUp_SignIn',
  ForgotPassword = 'B2C_1A_PasswordReset',
}
